// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__XVm5e","label":"SetPasswdForm_label__1iK-0"};